import React, { useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { RiDeleteBin6Line } from 'react-icons/ri';
import noImage from '../../asset/Product/no_image.png';
import {
  updateQuantityCartItem,
  deleteCartItem,
} from '../../redux/actions/cart';

const CartItem = (props) => {
  const { product } = props;
  const [quantity, setQuantity] = useState(product.count);
  const [quantityTemp, setQuantityTemp] = useState(product.count);

  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn, shallowEqual);
  const accessToken = useSelector((state) => state.auth.accessToken, shallowEqual);

  const dispatch = useDispatch();

  const onClickQuantity = (value) => {
    if (value && value !== '' && Number(value) > 0) {
      if (Number(value) > 0) {
        setQuantity(Number(value));
        setQuantityTemp(Number(value));
        dispatch(updateQuantityCartItem(
          product.product_id,
          Number(value),
          accessToken,
          isLoggedIn,
        ));
      }
    }
  };

  const onChangeQuantity = (value) => {
    if (value && value !== '' && Number(value) > 0) {
      if (Number(value) > 0) {
        setQuantityTemp(Number(value));
      }
    } else {
      setQuantityTemp('');
    }
  };

  const onBlurQuantity = (value) => {
    let qut;
    if (value === '') {
      qut = 1;
      setQuantity(1);
    } else {
      qut = quantityTemp;
      setQuantity(quantityTemp);
    }
    dispatch(updateQuantityCartItem(product.product_id, qut, accessToken, isLoggedIn));
  };

  const handleDeleteCartItem = (productId) => {
    dispatch(deleteCartItem(Number(productId), accessToken, isLoggedIn));
  };

  return (
    <div className="cart-product mb-4">
      <div className="cart-product-img">
        <img
        // onClick={() => gotoDetail(props.product.product_id)}
          src={product.image ? product.image : noImage}
          alt="product"
        />
      </div>
      <div className="cart-product-info pl-4">
        {product.name}
        <br />
        {product.volume}
        <p style={{ color: '#4e4e4e' }}>
          {product.price
            ? `¥ ${product.price.toLocaleString()}`
            : ''}
        </p>
      </div>
      <div className="cart-product-quantity">
        <span className="pr-1" style={{ color: '#224B71' }}>数量</span>
        <input
          style={{
            backgroundColor: '#B2CCDB',
            border: 'solid 1px #B2CCDB',
          }}
          className="change"
          type="button"
          value="-"
          onClick={() => onClickQuantity(Number(quantity) - 1)}
          disabled={quantity <= 1}
        />
        <input
          className="qty"
          type="number"
          min="1"
          value={quantityTemp}
          onChange={(e) => onChangeQuantity(e.target.value)}
          onBlur={(e) => onBlurQuantity(e.target.value)}
        />
        <input
          style={{
            backgroundColor: '#224B71',
            border: 'solid 1px #224B71',
          }}
          className="change"
          type="button"
          value="+"
          onClick={() => onClickQuantity(Number(quantity) + 1)}
        />
      </div>
      <div>
        <RiDeleteBin6Line
          className="delete-icon"
          size={18}
          onClick={(e) => {
            e.preventDefault();
            handleDeleteCartItem(product.product_id);
          }}
        />
      </div>
    </div>
  );
};
export default CartItem;
